import { FormattedMessage } from 'react-intl';

import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals';
import SummaryRow from '../../../../ui/summaryRow/SummaryRow';

const BalanceAfterTopup = ({
    totalBalance,
    isLoading
}: {
    totalBalance: number;
    isLoading: boolean;
}) => (
    <SummaryRow isLoading={isLoading}>
        <FormattedMessage
            id="_.draw_down.choose_amount.total_repayment"
            defaultMessage="Total repayment"
        />
        <span data-testid="early-repayment-total">
            <MoneyWithDecimals value={totalBalance} />
        </span>
    </SummaryRow>
);

// eslint-disable-next-line import/no-default-export
export default BalanceAfterTopup;
